import React, { useEffect, useState, useCallback } from "react";

import Navbar from "../components/Navbar";
import Header from "./Header";
// import "./Header.css";
import "./MyBookings.css";
import "./Disaccount.css";

import moment from "moment";

import { Link, useNavigate } from "react-router-dom";
import host from "../config";
const Disaccount = () => {
  const navigate = useNavigate();

  // let host = "https://api.vmrdarental.com";
  // let host = "https://api.vmrdarental.com";
  const [paginatedBookingList, setPaginatedBookingList] = useState([]);

  const [noData, setNoData] = useState();
  const [bookingData, setBookingData] = useState([]);
  const [bookingList, setBookingList] = useState([]);
  const [statusCheck, setStatusCheck] = useState(false);
  const [isShow, invokeModal] = React.useState(false);
  const [editableRoom, setEditableRoom] = React.useState({});

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;
  const [showPopup, setShowPopup] = useState(false);
  // const [cancellationReason, setCancellationReason] = useState("");
  // const [selectedBooking, setSelectedBooking] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [cancellationReason, setCancellationReason] = useState("");
  const [selectedBooking, setSelectedBooking] = useState(null);

  const [selectedRI, setSelectedRI] = useState(""); // Stores selected RI value
  const [selectedBookingId, setSelectedBookingId] = useState(null); // Stores the booking ID
  const [showDiscountModal, setShowDiscountModal] = useState(false);
  // const [selectedBooking, setSelectedBooking] = useState(null);
  const [discountPercentage, setDiscountPercentage] = useState("");
  const [discountReason, setDiscountReason] = useState("");
  const [damagedFile, setDamagedFile] = useState(null);
  const [electricityBill, setElectricityBill] = useState(null);
  const [discountFile, setDiscountFile] = useState("");
  const [discountFileUrl, setDiscountFileUrl] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  //  const [selectedBooking, setSelectedBooking] = useState(null);
  const [isChecked, setIsChecked] = useState(false);

  const [calculatedDiscount, setCalculatedDiscount] = useState(0); // ✅ Fix: Define state variable

  // Function to calculate discount amount dynamically
  const handleDiscountChange = (e) => {
    const percentage = parseFloat(e.target.value);
    setDiscountPercentage(percentage);

    if (!isNaN(percentage) && percentage >= 0 && percentage <= 100) {
      const rentPlusGst =
        (selectedBooking.total_rent || 0) + (selectedBooking.total_gst || 0);
      const discountAmount = (rentPlusGst * percentage) / 100;
      setCalculatedDiscount(discountAmount);
    } else {
      setCalculatedDiscount(0);
    }
  };

  const openModal = (booking) => {
    setSelectedBooking(booking);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedBooking(null);
    setIsChecked(false);
  };

  const openDiscountModal = (booking) => {
    setSelectedBooking(booking);
    setDiscountPercentage("");
    setDiscountReason("");
    setShowDiscountModal(true);
  };

  const openPopup = (bookingGroupId) => {
    setSelectedBookingId(bookingGroupId); // Store the ID for API call
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
    setSelectedRI(""); // Reset selection
  };

  const handleModalClose = () => {
    setShowModal(false);
    setCancellationReason("");
    setSelectedBooking(null);
  };

  const handleFileChange = async (e, fileType) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("image", file); // Key should match backend (upload.single('image'))
    formData.append("fileType", fileType);

    try {
      const response = await fetch(`${host}/upload`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Upload failed");
      }

      const result = await response.json();

      if (result.location) {
        // ✅ Fix: Use "location" instead of "fileUrl"
        if (fileType === "damagedFile") {
          setDamagedFile(result.location); // ✅ Fix: Store the correct URL
          localStorage.setItem("damagedFile", result.location);
        } else if (fileType === "electricityBill") {
          setElectricityBill(result.location);
          localStorage.setItem("electricityBill", result.location);
        } else if (fileType === "discountFile") {
          setDiscountFile(result.location);
          localStorage.setItem("discountFile", result.location);
        }
        alert(`File uploaded successfully`);
      } else {
        throw new Error("Invalid file URL from server");
      }
    } catch (error) {
      console.error(`Error uploading ${fileType}:`, error);
      alert(`Error uploading ${fileType}`);
    }
  };

  const handleApprove = async (bookingGroupId) => {
    if (!isChecked) {
      alert("Please confirm the details before approving.");
      return;
    }

    console.log("Approved Booking:", selectedBooking);

    try {
      console.log("Sending booking_group_id:", bookingGroupId); // Debugging

      const response = await fetch(`${host}/approveBooking`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        body: JSON.stringify({ booking_group_id: bookingGroupId }), // Send in the body
      });

      if (!response.ok) {
        throw new Error("Failed to approve booking");
      }

      const updatedBooking = await response.json();

      if (updatedBooking.success) {
        alert("Venue successfully approved!"); // Show alert

        // 🔄 Re-fetch latest booking data after approval
        myBookingsList();

        closeModal();
      } else {
        throw new Error("Approval failed");
      }
    } catch (error) {
      console.error("Error approving booking:", error);
    }
  };

  const handlePageChange = (newPage) => {
    console.log("Page changed to:", newPage);
    setCurrentPage(newPage);

    const newPaginatedBookingList = bookingList.slice(
      (newPage - 1) * itemsPerPage,
      newPage * itemsPerPage
    );

    setPaginatedBookingList(newPaginatedBookingList);
  };

  const myBookingsListCallback = useCallback(() => {
    // myBookingsList();
  }, []);

  useEffect(() => {
    if (
      !localStorage.getItem("access_token") ||
      localStorage.getItem("access_token") === ""
    ) {
      navigate("/", "_self");
    }

    myBookingsListCallback();
    myBookingsList();
  }, []);

  let userRole = localStorage.getItem("userRole");
  let billingRequest = JSON.parse("{}");
  let srNo = 0;
  if (
    localStorage.getItem("access_token") == undefined ||
    localStorage.getItem("access_token") === ""
  ) {
    navigate("/", "_self");
  }

  // Add this inside your component function
  useEffect(() => {
    console.log("Booking List:", bookingList);
  }, [bookingList]);

  const summaryView = (booking_group_id) => {
    fetch(
      host +
        "/getBookingSummary?bookingGroupId=" +
        booking_group_id +
        "&access_token=" +
        localStorage.getItem("access_token") +
        "&time=" +
        Math.round(new Date().getTime() / 1000),
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      }
    ).then((response) => {
      response.json().then((rooms) => {
        if (rooms.length === 0) {
          console.error("No rooms found");
          return;
        }

        let bookingDetailsDataFinal = [];
        const orderId = rooms[0].order_id;
        console.log("Order ID:", orderId);

        billingRequest.locationId = rooms[0].location_id;
        billingRequest.name = rooms[0].customer_name;
        billingRequest.address = rooms[0].address;
        billingRequest.contactno = rooms[0].contact_no;
        billingRequest.email = rooms[0].email_id;
        billingRequest.pan = rooms[0].pan_number;
        billingRequest.aadhaar = rooms[0].aadhaar_number;
        billingRequest.razorpay_status = rooms[0].razorpay_status;
        billingRequest.orderId = rooms[0].booking_id;
        billingRequest.bookingId = rooms[0].order_id;
        billingRequest.is_approved = rooms[0].is_approved;

        rooms.map((row) => {
          let tmpBookingDetailsDataFinal = JSON.parse("{}");
          tmpBookingDetailsDataFinal["room_name"] = row.room_name;
          tmpBookingDetailsDataFinal["bookingDate"] = row.date;
          tmpBookingDetailsDataFinal["amount"] = row.sub_total;
          tmpBookingDetailsDataFinal["selectedPersons"] = row.extra_persons;
          tmpBookingDetailsDataFinal["finalGrandTotalVal"] = row.sub_total;

          bookingDetailsDataFinal.push(tmpBookingDetailsDataFinal);
          console.log("Row Sub Total:", row.sub_total);
        });

        billingRequest.roomData = bookingDetailsDataFinal;
        localStorage.setItem("billingRequest", JSON.stringify(billingRequest));
        localStorage.setItem("bookingDetailsData", JSON.stringify("{}"));

        navigate("/BookingSummary", {
          state: {
            orderId: rooms[0].order_id,
            isApproved: rooms[0].is_approved,
          },
        });
      });
    });
  };

  console.log("tmpBookingDetailsDataFinal");
  const handleViewDocument = (fileUrl) => {
    if (!fileUrl) {
      alert("Document URL is not available.");
      return;
    }

    // Open the document in a new tab
    window.open(fileUrl, "_blank", "noopener,noreferrer");
  };

  const myBookingsList = async () => {
    try {
      const response = await fetch(
        host +
          "/getMyBookingsList?access_token=" +
          localStorage.getItem("access_token") +
          "&time=" +
          Math.round(new Date().getTime() / 1000),
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 403) {
        alert("Session expired. Please log in again.");
        localStorage.removeItem("access_token"); // Clear token
        navigate("/login", { replace: true }); // Redirect to login page
        return;
      }

      if (!response.ok) {
        throw new Error("Failed to fetch bookings");
      }

      const rooms = await response.json();
      console.log(rooms, "rooms");

      if (!Array.isArray(rooms)) {
        throw new Error("Invalid response format");
      }

      let bookingListArray = [];
      let bookingListTmp = {};

      if (rooms.length === 0) {
        setNoData("No booking details available");
      }

      rooms.forEach((row) => {
        // Group by booking_group_id and room_id
        const roomKey = `${row.booking_group_id}-${row.room_id}`;

        if (bookingListTmp[roomKey] !== undefined) {
          let tmp = bookingListTmp[roomKey];
          tmp.room_names = tmp.room_names + ", " + row.accommodation_type;

          // Ensure the sub_total is added only once for the room
          // Only add if the sub_total is not already set for this room in the group
          if (!tmp.sub_total) {
            tmp.sub_total = row.sub_total;
          }
          bookingListTmp[roomKey] = tmp;
        } else {
          row.room_names = row.accommodation_type;
          // Set sub_total once for each room in the booking group
          row.sub_total = row.sub_total;
          bookingListTmp[roomKey] = row;
        }
      });

      // Convert the object to an array
      Object.keys(bookingListTmp).forEach((key) => {
        bookingListArray.push(bookingListTmp[key]);
      });

      const updatedBookingList = bookingListArray.map((booking) => {
        const checkOutDate = moment(booking.date);
        const currentDate = moment();
        const isDateCompleted = currentDate.isAfter(checkOutDate, "day");

        return {
          ...booking,
          cancelDisabled: booking.status === "Canceled" || isDateCompleted,
        };
      });

      setBookingList(updatedBookingList);

      const newTotalPageCount = Math.ceil(
        updatedBookingList.length / itemsPerPage
      );
      setTotalPageCount(newTotalPageCount);

      // Update the paginated list based on the current page
      const newPaginatedBookingList = updatedBookingList.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      );

      setPaginatedBookingList(newPaginatedBookingList);

      console.log("Total Page Count:", newTotalPageCount);
    } catch (error) {
      console.error("Error fetching bookings:", error);
      alert(
        "There was an error fetching your bookings. Please try again later."
      );
    }
  };

  const handleApplyDiscount = async () => {
    if (!discountPercentage || !discountReason) {
      alert("Please enter both discount percentage and reason.");
      return;
    }
    const discountFileUrl = localStorage.getItem("discountFile") || "";
    // Calculate discount amount (on Rent + GST)
    const discountAmount =
      ((selectedBooking.total_rent + selectedBooking.total_gst) *
        discountPercentage) /
      100;

    try {
      const response = await fetch(`${host}/applyDiscount`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        body: JSON.stringify({
          booking_group_id: selectedBooking.booking_group_id,
          discount_percentage: discountPercentage,
          discount_amount: discountAmount, // Send calculated discount amount
          reason: discountReason,
          discountAttachment: discountFileUrl || "",
          uploaded_by_discount: userRole,
        }),
      });

      const result = await response.json();

      if (result.success) {
        alert("Discount applied successfully!");
        setShowDiscountModal(false);
        myBookingsList();
      } else {
        alert("Failed to apply discount.");
      }
    } catch (error) {
      console.error("Error applying discount:", error);
    }
  };

  const [totalPageCount, setTotalPageCount] = useState(1);

  const bookingSummary = () => {};

  const refreahData = () => {
    // myBookingsList();
  };

  const [filters, setFilters] = useState({
    checkInDate: "",
    bookingDate: "",
    customerName: "",
    venueName: "",
    status: "",
  });

  // const handleFilterChange = (e) => {
  //   setFilters({ ...filters, [e.target.name]: e.target.value });
  // };

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
    setCurrentPage(1); // optional: reset to first page on filter change
  };
  // const filteredBookings = bookingList.filter((rm) => {
  //   return (
  //     (!filters.checkInDate ||
  //       moment(rm.date).format("DD-MMM-YYYY") ===
  //         moment(filters.checkInDate).format("DD-MMM-YYYY")) && // Filter by check-in date
  //     (!filters.bookingDate ||
  //       moment(rm.booking_date).format("DD-MMM-YYYY") ===
  //         moment(filters.bookingDate).format("DD-MMM-YYYY")) && // Filter by booking date
  //     (!filters.customerName ||
  //       rm.customer_name
  //         .toLowerCase()
  //         .includes(filters.customerName.toLowerCase())) &&
  //     (!filters.venueName ||
  //       rm.room_names
  //         .toLowerCase()
  //         .includes(filters.venueName.toLowerCase())) &&
  //     (!filters.status || rm.status.toString() === filters.status)
  //   );
  // });
 
   const filteredBookings = bookingList.filter((rm) => {
  return (
    (!filters.checkInDate ||
      rm.dates?.split(",").some(
        (d) =>
          moment(d).format("DD-MMM-YYYY") ===
          moment(filters.checkInDate).format("DD-MMM-YYYY")
      )) &&
    (!filters.bookingDate ||
      moment(rm.booking_date).format("DD-MMM-YYYY") ===
        moment(filters.bookingDate).format("DD-MMM-YYYY")) &&
    (!filters.customerName ||
      rm.customer_name
        ?.toLowerCase()
        .includes(filters.customerName.toLowerCase())) &&
    (!filters.venueName ||
      rm.room_names
        ?.toLowerCase()
        .includes(filters.venueName.toLowerCase())) &&
    (!filters.app_status ||
      (rm.app_status || "")
        .toLowerCase()
        .includes(filters.app_status.toLowerCase()))
  );
});
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const paginatedFilteredBookings = filteredBookings.slice(
    startIndex,
    endIndex
  );

  useEffect(() => {
    // myBookingsList();
    myBookingsListCallback();
  }, [currentPage]);
  const onChangeLocation = () => {
    // myBookingsList();
    // populateAvailableRoomsInCalender(moment(nextDates[0]).format("DD-MMM-YYYY"));
    //checkAvailability();
  };
  return (
    <div>
      <Header />
      {/* <Navbar /> */}
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12  content_back">
            <div className="row">
              <b>Booking Details</b>
            </div>
            <br />

            <br />
            <div className="filter-container">
              <div className="filter-item">
                <label>Event Date:</label>
                <input
                  type="date"
                  name="checkInDate"
                  value={filters.checkInDate}
                  onChange={handleFilterChange}
                />
              </div>
              <div className="filter-item">
                <label>Booking Date:</label>
                <input
                  type="date"
                  name="bookingDate"
                  value={filters.bookingDate}
                  onChange={handleFilterChange}
                />
              </div>

              <div className="filter-item">
                <label>Customer Name:</label>
                <input
                  type="text"
                  name="customerName"
                  value={filters.customerName}
                  onChange={handleFilterChange}
                  placeholder="Enter Customer Name"
                />
              </div>

              <div className="filter-item">
                <label>Venue Name:</label>
                <input
                  type="text"
                  name="venueName"
                  value={filters.venueName}
                  onChange={handleFilterChange}
                  placeholder="Enter Venue Name"
                />
              </div>
            </div>

            <div className="row" style={{ overflowX: "auto" }}>
              <table className="table table-striped responsive-table">
                <thead>
                  <tr
                    className="data-row-head"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    <th>S No</th>
                    <th>Venue Details</th>

                    <th>Event Date</th>
                    <th>Contact Name</th>
                    <th>Contact No</th>

                    <th>Amount</th>

                    {(userRole == 1 || userRole == 3 || userRole == 4) && (
                      <th>Discount applied</th>
                    )}
                    {(userRole == 1 || userRole == 3|| userRole == 4) && <th>Discount %</th>}
                    {(userRole == 1 || userRole == 3|| userRole == 4) && (
                      <th>Discount Reason</th>
                    )}
                  </tr>
                </thead>
                <tbody style={{ whiteSpace: "nowrap" }}>
                  {paginatedFilteredBookings.map((rm, index) => (
                    <tr key={rm.booking_group_id} className="data-row-data">
                      <td style={{ textAlign: "center" }}>
                        {(currentPage - 1) * itemsPerPage + index + 1}
                      </td>
                      <td style={{ textAlign: "center" }}>{rm.room_names}</td>

                      {/* <td style={{ textAlign: "center" }}>
                        {rm.booking_group_id}
                      </td> */}
                      {/* <td style={{ textAlign: "center" }}>
                        {moment(rm.date).format("DD-MMM-YYYY")}
                      </td> */}

                                           <td style={{ textAlign: "center" }}>
  {rm.dates
    ? (() => {
        const arr = rm.dates.split(",").map(d => moment(d).format("DD-MMM-YYYY"));
        return arr.length === 1 ? arr[0] : `${arr[0]} to ${arr[arr.length - 1]}`;
      })()
    : "-"}
</td>
                      <td style={{ textAlign: "center" }}>
                        {rm.customer_name}
                      </td>
                      <td style={{ textAlign: "center" }}>{rm.contact_no}</td>

                      <td style={{ textAlign: "center" }}>{rm.sub_total}</td>

                      {/* Discount (Only for userRole 1) */}
                      {(userRole == 1 || userRole == 3|| userRole == 4) && (
                        <td>
                          {rm.discount}{" "}
                          <i
                            className="fa fa-edit"
                            style={{
                              cursor: "pointer",
                              color: "blue",
                              marginLeft: "5px",
                            }}
                            onClick={() => openDiscountModal(rm)}
                          ></i>
                        </td>
                      )}

                      {(userRole == 1 || userRole == 3|| userRole == 4) && (
                        <td>{rm.discount_percentage}</td>
                      )}

                      {(userRole == 1 || userRole == 3|| userRole == 4) && (
                        <td>{rm.discount_reason}</td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {showDiscountModal && selectedBooking && (
              <div className="modal-overlay">
                <div className="modal-container">
                  {/* Modal Header */}
                  <div className="modal-header">
                    <h2 className="modal-title">Apply Discount</h2>
                    <button
                      type="button"
                      className="close-btn"
                      onClick={() => setShowDiscountModal(false)}
                    >
                      ✖
                    </button>
                  </div>

                  {/* Modal Body */}
                  <div className="modal-content">
                    {/* Venue & Event Details */}
                    <div className="row">
                      <div className="col-4">
                        <p>
                          <strong>Venue :</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.accommodation_type || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Venue Type :</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.room_names || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Event Date :</strong>
                        </p>
                        <span className="roomnames">
                          {moment(selectedBooking.date).format("DD-MMM-YYYY")}
                        </span>
                      </div>
                    </div>

                    {/* Customer Info */}
                    <div className="row">
                      <div className="col-4">
                        <p>
                          <strong>Name:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.customer_name || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Phone:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.contact_no || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Email:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.email || "N/A"}
                        </span>
                      </div>
                    </div>

                    {/* Charges Table */}
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Rent</th>
                          <th>GST</th>
                          <th>Security Deposit</th>
                          <th>Cleaning Charges</th>
                          <th>Total Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>₹{selectedBooking.total_rent}</td>
                          <td>₹{selectedBooking.total_gst}</td>
                          <td>₹{selectedBooking.total_security_deposit}</td>
                          <td>₹{selectedBooking.total_cleaning_charges}</td>
                          <td>₹{selectedBooking.sub_total}</td>
                        </tr>
                      </tbody>
                    </table>

                    <div className="row">
                      {/* Left Section - Stacked Fields */}
                      <div className="col-4">
                        <label>Discount Percentage</label>

                     
                          {selectedBooking?.discount_percentage ? (
      <input
        type="text"
        value={`${selectedBooking.discount_percentage}%`}
        readOnly
        className="popup-input"
        style={{
          backgroundColor: "#f0f0f0",
          fontWeight: "bold",
          width: "100%",
        }}
      />
    ) : (
      <input
        type="number"
        value={discountPercentage === 0 ? "" : discountPercentage}
        onChange={(e) => {
          let raw = e.target.value;
          let cleaned = raw.replace(/^0+(?=\d)/, "");
          let value = cleaned === "" ? 0 : parseInt(cleaned);

          if (value > 100) {
            alert("Discount percentage cannot be more than 100%");
            return;
          }

          setDiscountPercentage(value);
          // setCalculatedDiscount(
          //   ((selectedBooking.total_rent + selectedBooking.total_gst) * value) /
          //     100
          // );
          const GST_PERCENT = 18;

const rent = selectedBooking.total_rent || 0;
const rentGst = (rent * GST_PERCENT) / 100;

setCalculatedDiscount(((rent + rentGst) * value) / 100);

        }}
        min="0"
        max="100"
        className="popup-input"
        placeholder="Enter discount %"
        style={{ width: "100%" }}
      />
    )}

                        <label style={{ marginTop: "10px" }}>
                          Discount Amount
                        </label>
                        {/* <input
                          type="text"
                          value={`₹${calculatedDiscount}`}
                          readOnly
                          className="popup-input"
                          style={{
                            backgroundColor: "#f0f0f0",
                            fontWeight: "bold",
                          }}
                        /> */}
                          {selectedBooking?.discount_amount ? (
      <input
        type="text"
        value={`₹${selectedBooking.discount_amount}`}
        readOnly
        className="popup-input"
        style={{
          backgroundColor: "#f0f0f0",
          fontWeight: "bold",
          width: "100%",
        }}
      />
    ) : (
      <input
        type="text"
        value={`₹${calculatedDiscount}`}
        readOnly
        className="popup-input"
        style={{
          backgroundColor: "#f0f0f0",
          fontWeight: "bold",
        }}
      />
    )}


                        <label style={{ marginTop: "10px" }}>
                          Discount Attachment
                        </label>
                        {selectedBooking.discount_attachment ? (
                          <a
                            href={selectedBooking.discount_attachment}
                            download
                            className="view-document-button"
                            style={{ display: "block", marginTop: "5px" }}
                          >
                            View Attachment
                          </a>
                        ) : (
                          <input
                            type="file"
                            accept=".jpg,.jpeg,.png,.pdf"
                            className="file-input"
                            onChange={(e) =>
                              handleFileChange(e, "discountFile")
                            }
                            style={{ display: "block", marginTop: "5px" }}
                          />
                        )}
                      </div>

                      {/* Right Section - Remarks */}
                      <div className="col-8">
                        <label>Remarks</label>
                        {/* <textarea
                          value={discountReason}
                          onChange={(e) => setDiscountReason(e.target.value)}
                          className="popup-textarea"
                          placeholder="Enter reason"
                          rows={4}
                          style={{ width: "100%", height: "131px" }}
                        /> */}
                        {selectedBooking?.discount_reason ? (
      <textarea
        value={selectedBooking.discount_reason}
        readOnly
        className="popup-textarea"
        rows={4}
        style={{
          width: "100%",
          height: "131px",
          backgroundColor: "#f0f0f0",
          fontWeight: "bold",
        }}
      />
    ) : (
      <textarea
        value={discountReason}
        onChange={(e) => setDiscountReason(e.target.value)}
        className="popup-textarea"
        placeholder="Enter reason"
        rows={4}
        style={{ width: "100%", height: "131px" }}
      />
    )}
                      </div>
                    </div>

                    <div className="row d-flex">
                      <span
                        style={{
                          color: "red",
                          fontWeight: "bold",
                          display: "inline",
                          width: "3%",
                        }}
                      >
                        ★
                      </span>
                      <span
                        style={{
                          display: "inline",
                          marginLeft: "5px",
                          width: "95%",
                          paddingLeft: "0px",
                        }}
                      >
                        Note: Discount is applied only to Rent and GST.
                      </span>
                    </div>
{/* RI Discount Section - Show only if applicable = Yes */}
{selectedBooking?.ri_applicable === "Yes" && (
  <div className="row" style={{ marginTop: "20px" }}>
    <div className="col-6">
      <label>RI Discount Applicable</label>
      <input
        type="text"
        value="Yes"
        readOnly
        className="popup-input"
        style={{
          backgroundColor: "#f0f0f0",
          fontWeight: "bold",
          width: "100%",
        }}
      />
    </div>

    {selectedBooking?.ri_discount_remarks && (
      <div className="col-6">
        <label>RI Discount Remarks</label>
        <textarea
          value={selectedBooking.ri_discount_remarks}
          readOnly
          className="popup-textarea"
          rows={4}
          style={{
            width: "100%",
            backgroundColor: "#f0f0f0",
            fontWeight: "bold",
          }}
        />
      </div>
    )}
  </div>
)}

                  </div>

                  {/* Modal Actions */}
                  <div className="modal-actions">
                    <button
                      onClick={handleApplyDiscount}
                      className="approve-btn"
                    >
                      Apply Discount
                    </button>
                    <button
                      onClick={() => setShowDiscountModal(false)}
                      className="cancel-btn"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            )}

            {isModalOpen && selectedBooking && (
              <div className="modal-overlay">
                <div className="modal-container">
                  <h2 className="modal-title">Approve Booking</h2>

                  <div className="modal-content">
                    <div className="modal-row">
                      <p>
                        <strong>Name:</strong>{" "}
                        <span>{selectedBooking.customer_name}</span>
                      </p>
                      <p>
                        <strong>Phone:</strong>{" "}
                        <span>{selectedBooking.contact_no}</span>
                      </p>
                    </div>
                    <div className="modal-row">
                      <p>
                        <strong>Check-in Date:</strong>{" "}
                        <span>
                          {moment(selectedBooking.date).format("DD-MMM-YYYY")}
                        </span>
                      </p>
                      <p>
                        <strong>Payment Status:</strong>{" "}
                        <span>{selectedBooking.razorpay_status}</span>
                      </p>
                    </div>
                    <div className="modal-row">
                      <p>
                        <strong>Amount:</strong>{" "}
                        <span>₹{selectedBooking.sub_total}</span>
                      </p>
                      <p>
                        <strong>Booking Status:</strong> <span>Confirmed</span>
                      </p>
                    </div>

                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={(e) => setIsChecked(e.target.checked)}
                      />
                      I confirm the details are correct.
                    </label>
                  </div>

                  <div className="modal-actions">
                    <button
                      onClick={() =>
                        handleApprove(selectedBooking.booking_group_id)
                      }
                      disabled={!isChecked}
                      className="approve-btn"
                    >
                      Approve
                    </button>

                    <button onClick={closeModal} className="cancel-btn">
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            )}

            <div className="col-lg-2"></div>
            <div className="pagination">
              <button
                className="btn-next-my"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Prev
              </button>
              <span
                style={{ paddingTop: "15px" }}
              >{`Page ${currentPage} of ${totalPageCount}`}</span>
              <button
                className="btn-next-my"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPageCount}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Disaccount;
